export type CaseFormat =
  | "camel"
  | "pascal"
  | "snake"
  | "kebab"
  | "constant"
  | "title";

export type CaseOutput = {
  format: CaseFormat;
  label: string;
  value: string;
};

function wordsFromInput(input: string) {
  return (
    input
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
      .match(/[A-Za-z0-9]+/g) ?? []
  ).map((word) => word.toLowerCase());
}

function capitalize(word: string) {
  return word ? word.charAt(0).toUpperCase() + word.slice(1) : word;
}

export function convertCase(input: string): CaseOutput[] {
  const words = wordsFromInput(input);
  const titleWords = words.map(capitalize);

  return [
    {
      format: "camel",
      label: "camelCase",
      value: words
        .map((word, index) => (index === 0 ? word : capitalize(word)))
        .join(""),
    },
    {
      format: "pascal",
      label: "PascalCase",
      value: titleWords.join(""),
    },
    {
      format: "snake",
      label: "snake_case",
      value: words.join("_"),
    },
    {
      format: "kebab",
      label: "kebab-case",
      value: words.join("-"),
    },
    {
      format: "constant",
      label: "CONSTANT_CASE",
      value: words.join("_").toUpperCase(),
    },
    {
      format: "title",
      label: "Title Case",
      value: titleWords.join(" "),
    },
  ];
}
